(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bot-notification', {
            parent: 'entity',
            url: '/bot-notification?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.botNotification.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bot-notification/bot-notifications.html',
                    controller: 'BotNotificationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('botNotification');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('bot-notification-detail', {
            parent: 'bot-notification',
            url: '/bot-notification/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.botNotification.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bot-notification/bot-notification-detail.html',
                    controller: 'BotNotificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('botNotification');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BotNotification', function($stateParams, BotNotification) {
                    return BotNotification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'bot-notification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('bot-notification-detail.edit', {
            parent: 'bot-notification-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bot-notification/bot-notification-dialog.html',
                    controller: 'BotNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BotNotification', function(BotNotification) {
                            return BotNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bot-notification.new', {
            parent: 'bot-notification',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bot-notification/bot-notification-dialog.html',
                    controller: 'BotNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                message: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('bot-notification', null, { reload: 'bot-notification' });
                }, function() {
                    $state.go('bot-notification');
                });
            }]
        })
        .state('bot-notification.edit', {
            parent: 'bot-notification',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bot-notification/bot-notification-dialog.html',
                    controller: 'BotNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BotNotification', function(BotNotification) {
                            return BotNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bot-notification', null, { reload: 'bot-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bot-notification.delete', {
            parent: 'bot-notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bot-notification/bot-notification-delete-dialog.html',
                    controller: 'BotNotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BotNotification', function(BotNotification) {
                            return BotNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bot-notification', null, { reload: 'bot-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
